export function fixAccessibilityRemoveIdsFromDuplicateSlides(e) {
    const sourcesList = e.wrapperEl.querySelectorAll(
        '.swiper-slide-duplicate source[id], .swiper-slide-duplicate img[id], .swiper-slide-duplicate-next source[id], .swiper-slide-duplicate-next img[id], .swiper-slide-duplicate-prev source[id], .swiper-slide-duplicate-prev img[id]',
    );

    sourcesList.forEach((source) => {
        source.removeAttribute('id');
    });
}

/**
 * Make content-cards height the same for all slides
 **/
export function equalizeCardsContentHeight(e) {
    const sliderContents = e.wrapperEl.querySelectorAll(
        '.m-card-image-text-a__content-wrapper',
    );

    let maxHeight = 0;
    sliderContents.forEach((slide) => {
        const slideHeight = parseInt(getComputedStyle(slide).height);
        if (maxHeight < slideHeight) {
            maxHeight = slideHeight;
        }
    });

    sliderContents.forEach((slide) => {
        slide.style.minHeight = `${maxHeight}px`;
    });
}
